"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBoardState = exports.BoardContextProvider = void 0;
exports.useTileBackgroundRenderer = useTileBackgroundRenderer;
const react_1 = require("react");
const useBoard_1 = require("./useBoard");
const BoardContext = (0, react_1.createContext)(null);
BoardContext.displayName = "BoardContext";
exports.BoardContextProvider = BoardContext.Provider;
const useBoard = () => (0, react_1.useContext)(BoardContext);
const useBoardState = () => (0, useBoard_1.useBoardSubscription)(useBoard().state);
exports.useBoardState = useBoardState;
function useTileBackgroundRenderer() {
    var _a;
    const context = useBoard();
    return (_a = context.tileBackgroundRenderer) !== null && _a !== void 0 ? _a : null;
}
